import { render, staticRenderFns } from "./LecturesFeedbackStatementEntityDetails.vue?vue&type=template&id=3df6824c&scoped=true"
import script from "./LecturesFeedbackStatementEntityDetails.vue?vue&type=script&lang=js"
export * from "./LecturesFeedbackStatementEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LecturesFeedbackStatementEntityDetails.vue?vue&type=style&index=0&id=3df6824c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df6824c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df6824c')) {
      api.createRecord('3df6824c', component.options)
    } else {
      api.reload('3df6824c', component.options)
    }
    module.hot.accept("./LecturesFeedbackStatementEntityDetails.vue?vue&type=template&id=3df6824c&scoped=true", function () {
      api.rerender('3df6824c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LecturesFeedbackStatementEntityDetails.vue"
export default component.exports